export default function asyncLoadView (asyncView) {

  // todo: add beautiful loader
  return asyncView;
}
